import { adminActionTypes } from "src/action_types/section_action_types";
import uniq from "lodash/uniq";
import without from "lodash/without";

export function admissionStatusFilterReducer(state = [], action) {
  switch (action.type) {
    case adminActionTypes.setAdmissionStatus: {
      return uniq([...state, action.payload]);
    }
    case adminActionTypes.deselectAdmissionStatus: {
      return without(state, action.payload);
    }
    default:
      return state;
  }
}
